import { render, staticRenderFns } from "./CrawlerControllerTemplate.vue?vue&type=template&id=25492535&scoped=true&"
import script from "./CrawlerControllerTemplate.vue?vue&type=script&lang=js&"
export * from "./CrawlerControllerTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CrawlerControllerTemplate.vue?vue&type=style&index=0&id=25492535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25492535",
  null
  
)

export default component.exports